import { pickBy, isEqual } from 'lodash';

export default function getEntityChangedFields(oldEntity, newEntity) {
  return pickBy(newEntity, (value, key) => !isEqual(oldEntity[key], value));
}
